<template>
  <div>
    <div :class="size">
      <canvas
        :ref="'chart'"
        class="chart"
      />
    </div>

    <div>
      <chart-legend
        :labels="labels"
        :datasets="datasets"
        @clicked="legendClicked"
      />
    </div>
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import ChartLegend from './ChartLegend.vue'

  export default {
    name: 'PieChart',
    components: { ChartLegend },
    props: {
      chartData: {
        type: Object,
        required: true
      },
      size: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        chartInstance: null
      }
    },
    computed: {
      labels () {
        return this.chartData.labels || []
      },
      datasets () {
        return this.chartData.datasets || []
      }
    },
    mounted () {
      this.chartInstance = new Chart(this.$refs.chart, {
        type: 'pie',
        data: {
          xAxisSuffix: this.chartData.xAxisSuffix,
          labels: this.getLabels(),
          datasets: this.datasets
        },
        options: {
          legend: {
            display: false
          },
          maintainAspectRatio: false,
          hover: { mode: null },
          tooltips: {
            enabled: false
          }
        },
        plugins: [{
          afterDraw: this.drawPieText
        }]
      })
    },
    methods: {
      getLabels () {
        if (this.chartData.labels) {
          this.chartData.labels.forEach((el, i) => {
            this.chartData.labels[i] = unescape(el) // eslint-disable-line vue/no-mutating-props
          })
        }

        return this.chartData.labels || []
      },
      legendClicked (data) {
        const meta = this.chartInstance.getDatasetMeta(data.setIndex)
        const element = meta.data[data.labelIndex]
        element.hidden = !element.hidden
        this.chartInstance.update()
      },
      drawPieText (chart) {
        const ctx = chart.controller.ctx
        for (const datasetIndex in chart.config.data.datasets) {
          const meta = chart.getDatasetMeta(datasetIndex)
          for (const dataIndex in meta.data) {
            const element = meta.data[dataIndex]
            if (element.hidden === true) {
              continue
            }
            const value = chart.config.data.datasets[datasetIndex].data[dataIndex]
            const meanAngle = (element._view.endAngle + element._view.startAngle) * 0.5
            const length = element._view.outerRadius * 0.5
            const p1 = { x: element._view.x, y: element._view.y }
            const p2 = {
              x: p1.x + (length * Math.cos(meanAngle)),
              y: p1.y + (length * Math.sin(meanAngle))
            }
            const text = `${value} ${this.chartData.xAxisSuffix}`
            ctx.font = this.chartData.font
            ctx.fillStyle = this.chartData.color
            ctx.textAlign = 'center'
            ctx.fillText(text, p2.x, p2.y)
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  canvas {
    height: 100%;
  }

  div {
    &.small {
      height: rem(200px);
    }

    &.normal {
      height: rem(400px);
    }

    &.large {
      height: rem(600px);
    }
  }

  .legend {
    margin-top: rhythm();
    justify-content: center;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &__item {
      display: flex;
      align-items: center;

      &__box {
        width: rhythm('medium');
        height: rhythm('half');
        margin: 0 rhythm('xsmall');
      }
    }
  }
</style>
